import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { QrCode, CheckCircle, Home } from 'lucide-react';

const ThankYouPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { message, formName } = location.state || {};
  
  useEffect(() => {
    // If no message was passed (user directly navigated here), redirect to home
    if (!message && !formName) {
      navigate('/');
    }
  }, [message, formName, navigate]);

  if (!message && !formName) {
    return null; // Will redirect via useEffect
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg overflow-hidden">
        <div className="px-4 py-5 sm:p-6">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
              <CheckCircle className="h-6 w-6 text-green-600" />
            </div>
            <h3 className="mt-2 text-lg leading-6 font-medium text-gray-900">
              Thank You!
            </h3>
            <div className="mt-2">
              <p className="text-sm text-gray-500">
                {message || "Your feedback has been submitted successfully. We will review your feedback and act on it. If you left contact information, we will get back to you."}
              </p>
            </div>
            <div className="mt-5">
              <Link
                to="/"
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                <Home size={16} className="mr-2" />
                Return Home
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      <div className="mt-8 text-center">
        <div className="flex justify-center">
          <QrCode size={32} className="text-blue-600" />
        </div>
        <p className="mt-2 text-sm text-gray-500">
          Powered by QR Feedback
        </p>
      </div>
    </div>
  );
};

export default ThankYouPage;